import { useContext } from 'react';

import { AntNotificationContext } from '../contexts/ant-notification-context';

export function useAntNotification() {
    return useContext(AntNotificationContext);
}
